export class Utils {
  public static jsonClone<T>(entry: T): T {
    if (!entry) {
      return entry;
    }
    return JSON.parse(JSON.stringify(entry));
  }

  public static getWeekStartDate(focusDate: Date) {
    let weekStart = new Date((focusDate).getTime() - new Date().getDay() * 24 * 60 * 60 * 1000)
    weekStart.setHours(0)
    weekStart.setMinutes(0)
    weekStart.setSeconds(0)
    weekStart.setMilliseconds(0)
    return weekStart
  }
  static getWeekEndDate(focusDate: Date) {
    const weekEnd = new Date(focusDate?.getTime() + (6 - focusDate?.getDay())*24*60*60*1000);
    weekEnd.setHours(23)
    weekEnd.setMinutes(59)
    weekEnd.setSeconds(59)
    weekEnd.setMilliseconds(999)
    return weekEnd
  }
}
